export const WebsiteURL = process.env.REACT_APP_WEBSITE_URL;
export const ApiBaseURL = process.env.REACT_APP_API_BASE_URL;
export const LineAuthCLientID = process.env.REACT_APP_LINE_AUTH_CLIENT_ID;
export const LineNotifyCLientID = process.env.REACT_APP_LINE_NOTIFY_CLIENT_ID;
export const LineAuthCallbackURL = WebsiteURL + '/#/line-auth-callback';
export const LineNotifyCallbackURL = WebsiteURL + '/#/enable-line-notify/callback';
export const StorageKeyTgLineState = 'tg-line-state';